import React from "react";

export default () => (
  <section>
    <h2>Frequently Asked Questions</h2>
    <p>
      <b>
        <i>How do we arrange for a consultation?</i>
      </b>
    </p>
    <p>
      My schedule is flexible and we can meet in person at a coffee shop,
      restaurant, or library. If this is not possible, we can talk over the
      phone or via email. In order to arrange for a consultations, please either
      send me an email or give me a call so we can agree on a specific date and
      time!
    </p>
    <p>
      <b>
        <i>What should we expect at the first meeting?</i>
      </b>
    </p>
    <p>
      At the first meeting I will introduce myself and ask you some questions
      about your upcoming ceremony and what you hope to include. I want to
      ensure that you and your partner have exactly what you are hoping for and
      I want to be sure that I am following your wishes.
      <br />
      <br />
      We will talk about what you want for your ceremony and if there are
      specific traditions that you would like to incorporate. Following our
      first meeting, we can work together to tailor the ceremony and/or vows if
      needed. We can continue to meeting in person if you would prefer, or we
      can communicate over the phone or via email up until the day of the
      rehearsal or ceremony.
    </p>
    <p>
      <b>
        <i>What happens after we confirm you as the officiant?</i>
      </b>
    </p>
    <p>
      Once we have talked about what you hope for on the day of your
      wedding/commitment ceremony and after you and your partner feel
      comfortable, we will want to confirm the date and time of the ceremony.
      (Please note that your ceremony date/time will not be reserved until I
      have been confirmed as your officiant.) I will require a 50% deposit in
      order to reserve your ceremony date and the remaining balance will need to
      be paid on or prior to the actual ceremony date. Once I have been
      confirmed as your officiant, you will receive a confirmation letter for
      your upcoming ceremony. I will then provide you will an outline of a
      proposed ceremony about 30-45 days prior to your ceremony for your
      feedback and/or approval. Or if you would prefer to have a more hands-on
      role, we will begin working together to develop your ceremony until it is
      exactly how you wish.
    </p>
    <p>
      <b>
        <i>How are payments made?</i>
      </b>
    </p>
    <p>Deposits and payments can be made by cash or check.</p>
    <p>
      <b>
        <i>What about the marriage license?</i>
      </b>
    </p>
    <p>
      In Washington State, a marriage license must be obtained at least 3 days
      prior to the ceremony, as there is a mandatory 3-day waiting period. No
      blood testing or birth certificates are required when applying. For more
      detailed information, please visit:{" "}
      <a href="http://access.wa.gov/living/resources/marriage.aspx">
        http://access.wa.gov/living/resources/marriage.aspx
      </a>
    </p>
    <p>
      <b>
        <i>What should we expect on the day of?</i>
      </b>
    </p>
    <p>
      On the day of the ceremony, I will arrive around 30-60 minutes prior to
      the start of the ceremony. It is best if all marriage license documents
      can be provided to be beforehand, as I can complete the necessary areas
      and be prepared prior to the start of the ceremony.
    </p>
    <p>
      <b>
        <i>Do we need a witness?</i>
      </b>
    </p>
    <p>
      Yes. In the State of Washington, it is required that each individual have
      one witness at the ceremony. For more information, please visit:{" "}
      <a href="http://access.wa.gov/living/resources/marriage.aspx">
        http://access.wa.gov/living/resources/marriage.aspx
      </a>
    </p>
    <p>
      <b>
        <i>Do you write the ceremony?</i>
      </b>
    </p>
    <p>
      I enjoy developing and tailoring each ceremony to the individual couple. I
      can write the entire ceremony and then provide it to you for feedback
      and/or approval, we can work together to ensure that everything you want
      is incorporated, or you can feel free to write the entire ceremony! The
      important thing is that you and your partner have your ceremony exactly
      how you wish. We can meet in person, talk over the phone, or via email to
      ensure that everything is finalized before your big day.
    </p>
    <p>
      <b>
        <i>Will you assist us or provide resources for writing our own vows?</i>
      </b>
    </p>
    <p>
      Yes. Many couples want to write their own vows, which makes the ceremony
      even more personalized. If needed, I can assist you in this process and
      provide you with resources to provide guidance.
    </p>
    <p>
      <b>
        <i>Can we incorporate other traditions into our ceremony?</i>
      </b>
    </p>
    <p>
      Absolutely! This is one of the best ways to personalize a ceremony. I have
      personal experience and knowledge of handfasting, unity
      candles/sand/water, jumping the broom, breaking of the glass, and other
      cultural wedding rituals and practices.
    </p>
    <p>
      <b>
        <i>What will you wear for the service?</i>
      </b>
    </p>
    <p>
      I am flexible and want the couple to have the ceremony that they envision.
      I am able to wear a suit, robe, khakis, jeans, or anything else within
      reason for the ceremony. We can also discuss this prior to your ceremony.
    </p>
    <p>
      <b>
        <i>Are you willing to travel?</i>
      </b>
    </p>
    <p>
      Yes. I am able to attend ceremonies within King and Pierce Counties and am
      willing to travel elsewhere if possible.
    </p>
    <p>
      <b>
        <i>What should we expect at the rehearsal?</i>
      </b>
    </p>
    <p>
      The rehearsal is meant as a time to run-through the ceremony so that
      everyone feels prepared for the actual formal ceremony. If needed, I am
      able to guide everyone through the ceremony so that the couple feels at
      ease for the big day. Rehearsals always last much longer than the actual
      ceremony and the couple and those involved should budget about 1-2 hours
      for the rehearsal and run-through.
    </p>
    <p>
      <b>
        <i>Do you enjoy officiating?</i>
      </b>
    </p>
    <p>
      Yes! I feel honored that you would choose me to assist in celebrating your
      special day!
    </p>
  </section>
);
